import { useState } from "react"

const KEY = "sidebar-calendar-visible"

export function useSidebarCalendar(): [boolean, () => void] {
  const [show, setShow] = useState(() => localStorage.getItem(KEY) !== "false")
  const toggle = () => {
    setShow((v) => {
      const next = !v
      localStorage.setItem(KEY, String(next))
      return next
    })
  }
  return [show, toggle]
}
